import { defineComponent as _defineComponent } from 'vue'
import AddMoneyModal from './AddMoneyModal.vue';
import CreateTradeModal from 'ah-trades/src/components/modals/CreateTradeModal.vue';
import DownloadStatementModal from 'ah-wallets/src/components/transactions/DownloadStatementModal.vue';
import WalletInfoTitle from './WalletInfoTitle.vue';
import WithdrawFromWalletModal from './WithdrawFromWalletModal.vue';
import { AuthorityType, Client } from 'ah-api-gateways';
import { useWalletState } from '..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, inject, reactive, watch } from 'vue';
import { ON_BEHALF_OF_CLIENT_INJECT_KEY } from 'ah-common-lib/src/onBehalfOf/constants';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletInfoHeaderMobile',
  props: {
    walletId: null,
    readonly: { type: [Boolean, String], default: false }
  },
  emits: ["back", "wallet-changed", "trade-completed"],
  setup(__props: any, { emit }: { emit: ({
  /**
   * when the back button is pressed
   */
  (e: 'back', value: void): void;
  /**
   * when a withdraw or a payment is made
   */
  (e: 'wallet-changed', value: void): void;
  /**
   * when a trade is finished
   */
  (e: 'trade-completed', value: void): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { walletId: string, readonly: boolean | string };

const walletState = useWalletState();

const requestManager = useRequestManager({
  exposeToParent: ['loadWallet'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'loadWallet') {
      loadWallet();
    }
  },
});



const state = reactive<{
  onBehalfOfClient: Client | null;
  tabIndex: number;
}>({
  onBehalfOfClient: inject(ON_BEHALF_OF_CLIENT_INJECT_KEY, null),
  tabIndex: 0,
});

const wallet = computed(() => walletState.store.useWalletsStore().getWalletById(props.walletId));



const canSeeFundingDetails = computed(() =>
  walletState.store.useAuthStore().hasAuthorities(AuthorityType.VIEW_FUNDING_DETAILS)
);

const openTradeAllowed = computed(
  () => state.onBehalfOfClient || walletState.store.useAuthStore().hasAuthorities(AuthorityType.OPEN_TRADE)
);

const requestPricesAllowed = computed(
  () => state.onBehalfOfClient || walletState.store.useAuthStore().hasAuthorities(AuthorityType.REQUEST_PRICES)
);

const withdrawAllowed = computed(() => !isReadonly.value && !state.onBehalfOfClient);

const sendMoneyAllowed = computed(
  () =>
    state.onBehalfOfClient ||
    (walletState.store.useAuthStore().hasAuthorities(AuthorityType.MAKE_PAYMENTS) && !isReadonly.value)
);

const isReadonly = computed(() => props.readonly !== false);

const selectedCurrency = computed(() => wallet.value?.currency ?? undefined);

const isClient = computed(() => walletState.store.useAuthStore().isClientUser);

function loadWallet() {
  requestManager.manager.newPromise(
    'loadWallet',
    walletState.store.useWalletsStore().loadWallet({ id: props.walletId, force: true })
  );
}

watch(() => props.walletId, loadWallet);

function onWithdraw() {
  emit('wallet-changed');
}

function onPaymentMade() {
  emit('wallet-changed');
}

function onTradeCompleted() {
  emit('trade-completed');
}

function goBack() {
  emit('back');
}

return { __sfc: true,walletState, requestManager, props, state, wallet, emit, canSeeFundingDetails, openTradeAllowed, requestPricesAllowed, withdrawAllowed, sendMoneyAllowed, isReadonly, selectedCurrency, isClient, loadWallet, onWithdraw, onPaymentMade, onTradeCompleted, goBack, AddMoneyModal, CreateTradeModal, DownloadStatementModal, WalletInfoTitle, WithdrawFromWalletModal }
}

})